var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-info-switch",on:{"click":_vm.switchStatus}},[_c('div',{staticClass:"switch-info"}),_c('div',{staticClass:"switch-text"},[_c('p',[_vm._v(_vm._s(_vm.status ? _vm.switchDesc : _vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }